import { z } from "zod";
import { baseEntitySchema } from "./base";

export const candidateTypeSchema = z.enum(["po", "so"]);
export type CandidateType = z.infer<typeof candidateTypeSchema>;

export const candidateStatusSchema = z.enum([
  "suggested",
  "approved",
  "rejected",
  "converted",
  "invalidated",
]);
export type CandidateStatus = z.infer<typeof candidateStatusSchema>;

export const orderCandidateDataSchema = z.object({
  candidateType: candidateTypeSchema,
  status: candidateStatusSchema,
  sourceDealId: z.string(),
  sourceStage: z.number(),
  sourceStageUpdatedAt: z.date(),
  customerId: z.string(),
  customerDisplayName: z.string().optional(),
  customerEmail: z.string().optional(),
  productId: z.string(),
  productName: z.string(),
  quantity: z.number().nonnegative(),
  amount: z.number().nonnegative(),
  unitPrice: z.number().nonnegative(),
  paymentOption: z
    .preprocess(
      (val) => (val === null || val === undefined || val === "" ? undefined : val),
      z
        .enum(["pay_in_advance", "pay_once_booked", "pay_after_booking"])
        .optional(),
    )
    .optional(),
  snapshot: z.record(z.string(), z.unknown()).optional(),
  reviewedBy: z.string().optional(),
  reviewedAt: z.date().optional(),
  reviewReason: z.string().optional(),
  convertedOrderId: z.string().optional(),
  convertedAt: z.date().optional(),
  revision: z.number().int().nonnegative().default(0),
});

export type OrderCandidateData = z.infer<typeof orderCandidateDataSchema>;
export const orderCandidateSchema = baseEntitySchema.merge(
  orderCandidateDataSchema,
);
export type OrderCandidate = z.infer<typeof orderCandidateSchema>;
